import Personnummer from 'personnummer';
import React, { ChangeEvent, FC, useState } from 'react';

// Hooks
import { useTranslation } from '../translations/useTranslation';

// Components
import { Button } from './Button';
import { ErrorMessage } from './ErrorMessage';

interface Props {
  onSubmit: (value: string) => void;
  isLoading: boolean;
}

const LoginNoEIdForm: FC<Props> = ({ onSubmit, isLoading }) => {
  const [value, setValue] = useState<string>('');
  const [touched, setTouched] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { t, keys } = useTranslation();

  const getErrorMessage = (): string | null => {
    if (value === null || value === '') {
      return t(keys.errorFillInRequiredFields);
    } else if (!Personnummer.valid(value)) {
      return t(keys.errorInvalidPersonalID);
    } else {
      return null;
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleBlur = () => {
    setTouched(true);
    setErrorMessage(getErrorMessage());
  };

  const handleSubmit = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    const errorMessage = getErrorMessage();
    if (!errorMessage) {
      onSubmit(value);
    } else {
      setErrorMessage(errorMessage);
    }
  };

  return (
    <form className="membership-app__login-form">
      <div className="membership-app__login-input">
        <label htmlFor="personalIdNumber">
          <span
            id="membership-app__login-input-labelId"
            className="membership-app__login-input-text"
          >
            {t(keys.formPersonalIdentityNumber)} / {t(keys.formCoordinationNumber)}
          </span>
          <input
            name="identifier"
            type="text"
            value={value}
            autoCorrect="off"
            pattern="[0-9]*"
            onChange={handleChange}
            onBlur={handleBlur}
            tabIndex={0}
            autoFocus
            aria-label="membership-app__login-input-labelId"
          />
        </label>
      </div>
      {(errorMessage && touched) && <ErrorMessage message={errorMessage} />}

      <Button
        title={t(keys.uiButtonNext)}
        onClick={handleSubmit}
        isLoading={isLoading}
      />
    </form>
  );
};

export default LoginNoEIdForm;
